import { animationsHandler } from './modules/animations';

document.addEventListener('DOMContentLoaded', function (event) {
    animationsHandler.init();
})